import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

import { ContentMetadata } from '@candu-ai/content/types';

import { EMBEDS_ROUTE, EmbedsPage } from './pages/Embeds';
import General, { GENERAL_ROUTE } from './pages/General';
import Permissions, { PERMISSIONS_ROUTE } from './pages/Permissions';
import { PLACEMENTS_ROUTE, PlacementsPage } from './pages/Placements';

type WithContextProps = {
  children: ({ contentMetadata }: { contentMetadata: ContentMetadata }) => JSX.Element;
};

const WithContext = ({ children }: WithContextProps) => {
  const { contentMetadata } = useOutletContext<{ contentMetadata: ContentMetadata }>();
  return children({ contentMetadata });
};

export const contentSettingsRoute = [
  { path: '', element: <Navigate to={GENERAL_ROUTE.path} replace /> },
  {
    path: GENERAL_ROUTE.path,
    element: <General />,
  },
  {
    path: PLACEMENTS_ROUTE.path,
    element: (
      <WithContext>
        {({ contentMetadata }) => <PlacementsPage content={contentMetadata} />}
      </WithContext>
    ),
  },
  {
    path: EMBEDS_ROUTE.path,
    element: (
      <WithContext>{({ contentMetadata }) => <EmbedsPage content={contentMetadata} />}</WithContext>
    ),
  },
  {
    path: PERMISSIONS_ROUTE.path,
    element: <Permissions />,
  },
];
